import { combineReducers } from "redux";
import userReducer from "./userSlice";
import roleSlice from "./roleSlice";
import settingReducer from "./settingsSlice";
import sessionReducer from "./sessionSlice";
import questionsReducer from "./QuestionsSlice/QuestionsSlice";
import tierReducers from "./tierSlice";

const appReducer = combineReducers({
  user: userReducer,
  roles: roleSlice,
  setting: settingReducer,
  session: sessionReducer,
  questions: questionsReducer,
  tiers: tierReducers,
});

// Handle Logout Action to Reset State
const rootReducer = (state, action) => {
  if (action.type === "LOGOUT") {
    state = {
      setting: state.setting,
    };
  }
  return appReducer(state, action);
};

export default rootReducer;
